<template>
  <div>
    <ul class="row no-gutters ml-n1 mt-n1 c-lg:ml-n2 c-lg:mt-n2 c-mb-0 list-unstyled">
      <ProductPropertiesItem
        v-for="property in properties"
        :key="property.id"
        :property-data="property"
      />
    </ul>
  </div>
</template>

<script setup>
import ProductPropertiesItem from '../products/ProductPropertiesItem.vue'

defineProps({
  properties: {
    type: Array,
    required: true,
  },
})
</script>
